<div class="container-fluid mb-3">
    <div class="d-flex flex-row justify-content-between align-items-center">
        <h2 class="title">Fiberglass Processing Method</h2>
        <div class="d-flex align-items-center justify-content-center">
            <button class="btn btn-outline-primary button btn-add text-white mr-3" (click)="export()" [disabled]="!canUpdate()">Export</button>
            <button class="btn btn-primary d-flex justify-content-center align-items-center btn-add button"
                (click)="addNewSupplier()">Add</button>
        </div>
    </div>
    <mat-card class="mt-2" style="font-size: 14px;">
        <div class="row">
            <div class="col-lg-4">
                <span>Search</span>
                <mat-form-field appearance="outline" class="w-100">
                    <input matInput [maxLength]="50" [(ngModel)]="search" placeholder="Search">
                    <mat-hint align="end">{{search?.length || 0}} / 50</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-3">
                <span>Created By</span>
                <mat-form-field appearance="outline" class="w-100">
                    <input matInput [maxLength]="50" [(ngModel)]="createdBy" placeholder="Created By">
                    <mat-hint align="end">{{createdBy?.length || 0}} / 50</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-3">
                <!-- Created Date Range Input -->
                <span>Creation Date</span>
                <mat-form-field appearance="outline" class="w-100">
                    <input tabindex="-1" readonly matInput [owlDateTime]="createdDateRangeODT" placeholder="Created Date"
                        [owlDateTimeTrigger]="createdDateRangeODT" placeholder="Created Date Range" [(ngModel)]="createdDateRange"
                        [selectMode]="'range'" />
                    <owl-date-time [pickerType]="'calendar'" #createdDateRangeODT placeholder="Created Date Range"></owl-date-time>
                    <button *ngIf="createdDateRange"
                        (click)="createdDateRange = null" mat-icon-button matSuffix>
                        <mat-icon class="mt-custom">clear</mat-icon>
                    </button>
                    <mat-datepicker-toggle [owlDateTimeTrigger]="createdDateRangeODT"
                        *ngIf="!createdDateRange" matSuffix></mat-datepicker-toggle>
                </mat-form-field>
            </div>
            <div class="col-lg-2 d-flex align-items-center justify-content-center">
                <button class="btn-add btn btn-outline-primary search-button" (click)="searchData()">Search</button>
            </div>
        </div>
    </mat-card>
    <div class="table-horizontal-scroll mt-4">
    <table mat-table [dataSource]="dataSource" matSort class="w-100" (matSortChange)="sortData($event)">

        <!-- Checkbox column -->
        <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef class="checkbox-column text-center pt-6-custom">
                <mat-checkbox
                    [checked]="isAllRowsSelected()"
                    [indeterminate]="isSomeRowsSelected()"
                    (change)="toggleAllRows($event.checked)">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="checkbox-column text-center">
                <mat-checkbox [checked]="row.isChecked" (change)="toggleRow(row)"></mat-checkbox>
            </td>
        </ng-container>

        <!-- Processing Method column -->
        <ng-container matColumnDef="processingMethod">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="bold-header">Fiberglass Processing Method </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="text" matInput [maxLength]="250" [(ngModel)]="row.processingMethod" placeholder="Processing Method" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.processingMethod}}</span>
            </td>
        </ng-container>

        <!-- Created By column -->
        <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Created By </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="text" matInput [maxLength]="250" [(ngModel)]="row.createdBy" placeholder="Created By" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.createdBy}}</span>
            </td>
        </ng-container>

        <!-- Creation Date column -->
        <ng-container matColumnDef="creationDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Creation Date </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="datetime-local" [(ngModel)]="row.creationDate" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.createdDate}}</span>
            </td>
        </ng-container>
        
        <!-- Last Updated By column -->
        <ng-container matColumnDef="lastUpdatedBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Last Updated By </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="text" matInput [maxLength]="250" [(ngModel)]="row.lastUpdatedBy" placeholder="Last Updated By" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.updatedBy}}</span>
            </td>
        </ng-container>
        
        <!-- Last Updated Date column -->
        <ng-container matColumnDef="lastUpdatedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Last Updated Date </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="datetime-local" [(ngModel)]="row.lastUpdatedDate" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.updatedDate}}</span>
            </td>
        </ng-container>
       
        <!-- Record ID column -->
        <ng-container matColumnDef="recordId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Record ID </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="number" min="0" step="1" [(ngModel)]="row.recordId" placeholder="Record ID" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.id}}</span>
            </td>
        </ng-container>
        
        <!-- attribute1 column -->
        <ng-container matColumnDef="attribute1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Attribute 1 </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="text" matInput [maxLength]="250" [(ngModel)]="row.attribute1" placeholder="Attribute 1" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.attribute1}}</span>
            </td>
        </ng-container>
        
        <!-- attribute2 column -->
        <ng-container matColumnDef="attribute2">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Attribute 2 </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="text" matInput [maxLength]="250" [(ngModel)]="row.attribute2" placeholder="Attribute 2" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.attribute2}}</span>
            </td>
        </ng-container>
        
        <!-- attribute3 column -->
        <ng-container matColumnDef="attribute3">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Attribute 3 </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="text" matInput [maxLength]="250" [(ngModel)]="row.attribute3" placeholder="Attribute 3" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.attribute3}}</span>
            </td>
        </ng-container>
        
        <!-- attribute4 column -->
        <ng-container matColumnDef="attribute4">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Attribute 4 </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="text" matInput [maxLength]="250" [(ngModel)]="row.attribute4" placeholder="Attribute 4" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.attribute4}}</span>
            </td>
        </ng-container>
        
        <!-- attribute5 column -->
        <ng-container matColumnDef="attribute5">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disabled> Attribute 5 </th>
            <td mat-cell *matCellDef="let row">
                <!-- <input *ngIf="row.isNew || row.isEditing" type="text" matInput [maxLength]="250" [(ngModel)]="row.attribute5" placeholder="Attribute 5" class="edit-cell-input"> -->
                <span *ngIf="!row.isNew && !row.isEditing">{{row?.attribute5}}</span>
            </td>
        </ng-container>

        <!-- Action column -->
        <ng-container matColumnDef="action" stickyEnd>
            <th class="action-sticky-column" mat-header-cell *matHeaderCellDef style="text-align: center;"> Action </th>
            <td class="action-sticky-column" mat-cell *matCellDef="let row" style="text-align: center;">
                <div class="d-flex justify-content-center align-items-center">
                    <span class="material-icons action" (click)="edit(row.id)" style="cursor: pointer;"
                        [matTooltip]="'Edit'">
                        create </span>
                    <i class="fa fa-trash px-2 action delete" aria-hidden="true" [matTooltip]="'Remove'"
                        (click)="deleteUser(row?.id, type)" style="cursor: pointer; font-size:23px"></i>
                    <!-- <mat-slide-toggle class="example-margin" [checked]="row.active"
                        (change)="changeActive(row.id, $event)">
                    </mat-slide-toggle> -->
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="noRecord">
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length" style="white-space: nowrap">
                No records found!
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr
          mat-footer-row
          *matFooterRowDef="['noRecord']"
          [ngClass]="{'d-none': !(dataSource != null && dataSource.data.length === 0)}"
        ></tr>
    </table>
    </div>
    <app-ngx-mat-paginator class="w-100" *ngIf="!!dataSource && dataSource.data.length > 0"
        [requestOption]="requestOption" (requestOptionChange)="onChangeRequestOption($event)"></app-ngx-mat-paginator>
</div>